import React from 'react';

import ScanSelfService from '@/ebat/components/pages/ScanSelfService/ScanSelfService';
import ScanSelfServiceAutosuggestionsProvider from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceAutosuggestionsContext';
import ScanSelfServiceProvider from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';
import ScanSelfServiceOverlayProvider from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceOverlayContext';

const ScanSelfServiceContainer = () => (
  <ScanSelfServiceProvider>
    <ScanSelfServiceAutosuggestionsProvider>
      <ScanSelfServiceOverlayProvider>
        <ScanSelfService />
      </ScanSelfServiceOverlayProvider>
    </ScanSelfServiceAutosuggestionsProvider>
  </ScanSelfServiceProvider>
);

export default ScanSelfServiceContainer;
